import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function ClientLogo({
  userID,
  exLogo1,
  setExLogo1,
  showSelectImage,
  dataForImageUpload,
}) {
  const { API_URL } = useContext(UrlContext);
  const [newUpload, setNewUpload] = useState(false);
  const dropArea = useRef(null);
  const galleryProfileRef = useRef(null);
  const progressBarRef = useRef(null);

  const [exLogo1Loading, setExLogo1Loading] = useState(false);
  const [exLogo1Success, setExLogo1Success] = useState(false);
  const [exLogo1Error, setExLogo1Error] = useState(false);

  useEffect(() => {
    handleProfileUploadClick();
  }, showSelectImage);

  const handleProfileUploadClick = () => {
    $(".uploadLogo1-popup-wrapper").fadeIn();
  };

  const handleProfileUploadCancel = () => {
    galleryProfileRef.current.innerHTML = `<img src="" id="exLogo1" style="display: none;">`;
    progressBarRef.current.value = 0;
    $(".uploadLogo1-popup-wrapper").fadeOut();
    window.location.reload();
  };

  const handleProfileUpload = () => {
    const exLogo1URL = galleryProfileRef.current.firstChild.src;
    console.log("exLogo1URL", exLogo1URL);
    dataForImageUpload.profilePicture = exLogo1URL;

    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}account-update`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(dataForImageUpload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          galleryProfileRef.current.innerHTML = `<img src="" id="exLogo1" style="display: none;">`;
          progressBarRef.current.value = 0;
          $(".uploadLogo1-popup-wrapper").fadeOut();
          Swal.fire({
            icon: "success",
            title: "Profile picture has been updated",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        window.location.reload();
      });

    // if (exLogo1URL) {
    //    if (galleryProfileRef.current.childNodes.length === 2) {
    //       const exImageURL2 = galleryProfileRef.current.firstChild.src;
    //       // setExpertData({...expertData, logo1: exImageURL2});
    //       setExLogo1(exImageURL2);
    //       setNewUpload(false);
    //       saveExLogo1(exImageURL2);
    //    } else {
    //       // setExpertData({...expertData, logo1: exLogo1URL});
    //       setExLogo1(exLogo1URL);
    //       setNewUpload(false);
    //       saveExLogo1(exLogo1URL);
    //    }
    // }
  };

  const preventDefaults = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    preventDefaults(e);
    dropArea.current.classList.add("highlight");
  };

  const handleDragOver = (e) => {
    preventDefaults(e);
  };

  const handleDragLeave = (e) => {
    preventDefaults(e);
    dropArea.current.classList.remove("highlight");
  };

  useEffect(() => {
    const dropAreaElement = dropArea.current;
    const preventDefaultEvents = (e) => {
      preventDefaults(e);
    };
    const highlight = (e) => {
      dropAreaElement.classList.add("highlight");
    };
    const unhighlight = (e) => {
      dropAreaElement.classList.remove("active");
    };
    const handleDrop = (e) => {
      preventDefaults(e);
      dropAreaElement.classList.remove("highlight");
      handleFiles(e);
    };
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, preventDefaultEvents, false);
      document.body.addEventListener(eventName, preventDefaultEvents, false);
    });
    ["dragenter", "dragover"].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, highlight, false);
    });
    ["dragleave", "drop"].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, unhighlight, false);
    });
    dropAreaElement.addEventListener("drop", handleDrop, false);
  }, []);

  const initializeProgress = (numFiles) => {
    progressBarRef.current.value = 0;
  };

  const updateProgress = (percent) => {
    progressBarRef.current.value = percent;
  };

  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: "image/png" });
  };

  const handleFiles = async (e) => {
    console.log("here in handle");
    console.log(e);
    // console.log(e.dataTransfer.getData('text/html'))

    if (e.target.files) {
      let files = [...e.target.files];
      initializeProgress(e.target.files.length);
      files.forEach((file, index) => {
        previewFile(file);
      });
    } else if (e.dataTransfer.files.length > 0) {
      let files = [...e.dataTransfer.files];
      initializeProgress(e.dataTransfer.files.length);
      files.forEach((file, index) => {
        previewFile(file);
      });
    } else {
      const url = e.dataTransfer.getData("text/html");
      const parser = new DOMParser();
      const doc = parser.parseFromString(url, "text/html");
      const imgElement = doc.querySelector("img");
      // const match = /src=['"](data:image\/[^'"]+)['"]/i.exec(url);

      if (imgElement) {
        const imageURL = imgElement.getAttribute("src");
        if (imageURL.includes("data:image")) {
          const blob = dataURItoBlob(imageURL);
          const file = new File([blob], "image.png", { type: "image/png" });
          previewFile(file);
        } else {
          try {
            const response = await fetch(imageURL);
            if (response.ok) {
              const blob = await response.blob();
              const file = new File([blob], "image.png", { type: "image/png" });
              previewFile(file);
            } else {
              console.error("Failed to fetch image");
            }
          } catch (error) {
            console.error("Error fetching image:", error);
          }
        }
      }
    }
  };

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      galleryProfileRef.current.innerHTML = `<img src="${reader.result}" id="exLogo1" />`;
      $("#exLogo1").show();
    };
  };

  return (
    <>
      {/*---------------------- upload logo1 popup -----------------------*/}
      <div className="uploadLogo1-popup-wrapper">
        <div className="tab-pane fade show uploadLogo1-div">
          <h4 className="mb-3">Upload User Profile Picture</h4>
          <div className="row">
            <div
              ref={dropArea}
              id="drop-area-logo1"
              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(e) => {
                preventDefaults(e);
                handleFiles(e);
              }}
            >
              <form className="my-form">
                <p>Drag &amp; Drop here.....</p>
                <input
                  type="file"
                  id="fileElemLogo1"
                  accept="image/*"
                  onChange={(e) => handleFiles(e)}
                />
                <label className="button-label" htmlFor="fileElemLogo1">
                  Select Photo
                </label>
              </form>
              <progress
                id="progress-bar-logo1"
                max={100}
                value={0}
                ref={progressBarRef}
              />
              <div
                id="gallery-logo1"
                contentEditable="true"
                ref={galleryProfileRef}
              >
                <img src="" id="exLogo1" style={{ display: "none" }} alt="" />
              </div>
            </div>
          </div>
          <div>
            <center>
              <button
                type="button"
                className="btn btn-light"
                onClick={handleProfileUploadCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn base-btn"
                onClick={handleProfileUpload}
              >
                Update
              </button>
            </center>
          </div>
        </div>
      </div>
    </>
  );
}
